import ImprimirCodigoProducto from "./ImprimirCodigoContainer";
export default ImprimirCodigoProducto;
